export const compositionSearchModalTranslationJP = {
  CompositionSearchModal: {
    select: '選択',
    code: 'コード',
    name: '名称',
    search: '名称・コード検索',
    SMS_code: 'SMSコード',
    add: '追加',
  },
};
